import { render } from "./OptionPanel.vue?vue&type=template&id=6fdb89c6"
import script from "./OptionPanel.vue?vue&type=script&lang=js"
export * from "./OptionPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../irap-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__